<template>
  <div class="main-menu">
    <div class="main-menu-flex-wrapper">

      <div class="back-button" @click="historyBack()"><i class="fal fa-undo"></i></div>

      <!-- HEM -->
      <div class="menu-item-wrapper">
        <div class="sub-menu" v-if="activeSubMenu === 'home'">
          <router-link class="sub-menu-item" to="/home/project-owner"><span @click="resetFilter('projectsOwner')">Ansvarig</span></router-link>
          <router-link class="sub-menu-item" to="/home/project-reviewer"><span @click="resetFilter('projectsReviewer')">Granskare</span></router-link>
          <router-link class="sub-menu-item" to="/home/work-orders"><span @click="resetFilter('workOrders')">Insatser</span></router-link>
          <router-link class="sub-menu-item" to="/home/share"><span @click="resetFilter('workOrdersShare')">Dela</span></router-link>
        </div>
        <div class="menu-item" @click="openSubMenu('home')">
          <i class="fal fa-compass menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Hem</div>
        </div>
      </div>

      <!-- KUND -->
      <router-link class="menu-item-wrapper" :to="{ name: 'Customers' }" :class="{ 'is-active': isMenuActive('customers') }">
        <div class="menu-item" @click="resetFilter('customers')">
          <i class="fal fa-building menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Kund</div>
        </div>
      </router-link>

      <!-- PROJEKT -->
      <router-link class="menu-item-wrapper" :to="{ name: 'Projects' }" :class="{ 'is-active': isMenuActive('projects') }">
        <div class="menu-item" @click="resetFilter('projects')">
          <i class="fal fa-sitemap menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Projekt</div>
        </div>
      </router-link>

      <!-- KONTAKT -->
      <div class="menu-item-wrapper">
        <div class="sub-menu" v-if="activeSubMenu === 'contacts'">
          <router-link class="sub-menu-item" to="/contact/persons"><span @click="resetFilter('contacts')">Personer</span></router-link>
          <router-link class="sub-menu-item" to="/contact/addresses"><span @click="resetFilter('addresses')">Adresser</span></router-link>
        </div>
        <div class="menu-item" @click="openSubMenu('contacts')">
          <i class="fal fa-address-card menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Kontakt</div>
        </div>
      </div>

      <!-- FAKTURERA -->
      <!--
      <router-link class="menu-item-wrapper" :to="{ name: 'Invoices' }" :class="{ 'is-active': isMenuActive('projects') }">
        <div class="menu-item" @click="openSubMenu('invoices')">
          <i class="fal fa-file-invoice-dollar menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Fakturera</div>
        </div>
      </router-link>
      -->

      <div class="menu-item-wrapper">
        <div class="sub-menu" v-if="activeSubMenu === 'invoices'">
          <router-link class="sub-menu-item" to="/invoices"><span @click="resetFilter('projectsInvoice')">Fakturera</span></router-link>
          <router-link class="sub-menu-item" to="/invoices/archive/my"><span @click="resetFilter('invoicesOwner')">Ansvarig</span></router-link>
          <router-link class="sub-menu-item" to="/invoices/archive/overdue"><span @click="resetFilter('invoicesOverdue')">Förfallna</span></router-link>
          <router-link class="sub-menu-item" to="/invoices/archive"><span @click="resetFilter('invoices')">Reskontra</span></router-link>
        </div>
        <div class="menu-item" @click="openSubMenu('invoices')">
          <i class="fal fa-file-invoice-dollar menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Fakturor</div>
        </div>
      </div>

      <!-- TIDRAPPORT -->
      <!--  <div class="menu-item-wrapper">
        <div class="sub-menu" v-if="activeSubMenu === 'time-report'">
          <router-link class="sub-menu-item" to="/time-report/create">Skapa</router-link>
          <router-link class="sub-menu-item" to="/time-report/history">Historik</router-link>
          <router-link class="sub-menu-item" to="/time-report/balance">Saldo</router-link>
        </div>
        <div class="menu-item" @click="openSubMenu('time-report')">
          <i class="fal fa-clock menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Tidrapport</div>
        </div>
      </div> -->

      <!-- INSTÄLLNINGAR -->
      <div class="menu-item-wrapper">
        <div class="sub-menu" v-if="activeSubMenu === 'settings'">
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/superadmin/users"><span @click="resetFilter('users')">Användare</span></router-link>
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/superadmin/price-lists-default"><span @click="resetFilter('priceListDefault')">Årsprislista</span></router-link>
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/superadmin/price-lists-customer"><span @click="resetFilter('priceListCustomer')">Kundprislista</span></router-link>
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/superadmin/delivery-templates"><span @click="resetFilter('deliveryTemplates')">Leverans</span></router-link>
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/superadmin/tags">Taggar</router-link>
          <router-link v-if="isDeveloper()" class="sub-menu-item" to="/settings/dev">Dev</router-link>
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/settings/products"><span @click="resetFilter('products')">Produkter</span></router-link>
          <router-link class="sub-menu-item" to="/settings/preferences">Gränssnitt</router-link>
          <router-link v-if="isSuperAdmin()" class="sub-menu-item" to="/settings/system-settings">System</router-link>
          <hr style="margin:0">
          <div class="sub-menu-item" @click="logout()">Logga ut</div>
        </div>
        <div class="menu-item" @click="openSubMenu('settings')">
          <i class="fal fa-cog menu-item-icon dismiss-outside-click"></i>
          <div class="menu-item-text dismiss-outside-click">Inställningar</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      activeSubMenu: null,
      activeMenu: 'home'
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('auth', ['logout']),

    resetFilter (dataType) {
      this.$store.dispatch(dataType + '/resetFilter')
    },

    historyBack () {
      if (this.$routerHistory.hasPrevious()) {
        if (this.$routerHistory.previous().path === '/') {
          this.$toast('Sakta i backarna, nu höll du på att logga ut!')
        } else {
          this.$router.go(-1)
        }
      } else {
        console.warn('There is no history')
      }
    },

    openSubMenu (subMenuName) {
      if (subMenuName === this.activeSubMenu) {
        this.activeSubMenu = null
      } else {
        this.activeSubMenu = subMenuName
      }
    },

    isMenuActive (routeName) {
      return this.$route.name.toLowerCase().startsWith(routeName.toLowerCase())
    },

    isSuperAdmin () {
      return this.user.role === 'SuperAdmin' || this.user.role === 'Developer'
    },

    isDeveloper () {
      return this.user.role === 'Developer'
    },

    hasClass (element, testClass) {
      if ('classList' in element) {
        return element.classList.contains(testClass)
      } else {
        return new RegExp(testClass).exec(element.className)
      }
    }
  },

  created () {
    window.onclick = event => {
      const el = event.target

      if (this.hasClass(el, 'menu-item') || this.hasClass(el, 'dismiss-outside-click')) {
        return
      }
      this.activeSubMenu = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/BottomMenu.vue